import { find } from "lodash";

const initialState = {
  salesChannels: [],
  savingSalesChannel: false,
  closeModal: false,
  totalPages: 0
};

const salesChannelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'START_SAVING_SALES_CHANNEL_REQUEST':
      return {
        ...state,
        savingSalesChannel: true
      };
    case 'END_SAVING_SALES_CHANNEL_REQUEST':
      return {
        ...state,
        savingSalesChannel: false
      };
    case 'TOGGLE_MANAGE_SALES_CHANNEL_MODAL':
      return {
        ...state,
        closeModal: action.payload.toggle
      };
    case 'GET_SALES_CHANNELS':
      return {
        ...state,
        salesChannels: action.payload.sales_channels,
        totalPages: action.payload.total_pages
      };
    case 'CREATE_SALES_CHANNELS': {
      let { salesChannels } = state;
      const salesChannelIn = find(salesChannels, {web_id: action.payload.sales_channel.web_id});

      if (!salesChannelIn) salesChannels.unshift(action.payload.sales_channel);

      return {
        ...state,
        salesChannels,
        closeModal: true
      };
    }
    case 'UPDATE_SALES_CHANNELS': {
      let { salesChannels } = state;
      const updatedChannel = action.payload.sales_channel;
      salesChannels = salesChannels.map((channel) => (
        updatedChannel.web_id === channel.web_id ? updatedChannel : channel
      ));

      return {
        ...state,
        salesChannels,
        closeModal: true
      };
    }
    case 'REMOVE_SALES_CHANNELS': {
      return {
        ...state,
        salesChannels: state.salesChannels.filter((item) => item.web_id !== action.payload.sales_channel.web_id)
      };
    }
    default:
      return state;
  }
};

export default salesChannelsReducer;
